<template>
  <div>
    <div class="secondActions-container d-flex">
      <div
        class="flex-grow-1 py-sm-2 action-container color-secundary"
        v-for="(action, idx) in action"
        :class="action.enable ? 'cursor' : 'image-disable'"
        v-bind:key="idx"
        @click="action.enable && goToSelectedRoute(action)"
      >
        <div v-if="action.img" class="mb-1">
          <img
            :src="action.img"
            class="imageStyle material-icons align-middle color-secundary"
            alt="image"
          />
        </div>
        <div v-else>
          <span class="icon222Style material-icons-round  text-secundary">
            {{ action.text }}
          </span>
        </div>
        <div>
          <span class="text-secundary">
            {{ action.title }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import notificationToastMixin from '@/Mixins/notificationToast.mixin';
import { useSessionStore } from '@/common';
export default {
  props: {
    action: Array,
  },
  data: function() {
    const sessionStore = useSessionStore();
    return {
      sessionStore,
      actionsWithoutAccess: {
        Rate: 'Rate',
      },
    };
  },
  computed: {
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
    parentCanEdit() {
      return this.sessionStore.getCurrentChild.parentCanEdit;
    },
  },
  mixins: [notificationToastMixin],
  methods: {
    goToSelectedRoute(action) {
      const { title, router } = action;
      if (this.userIsAParent && !this.parentCanEdit && this.actionsWithoutAccess[title]) {
        this.readOnlyUserNotificationToast();
        return;
      }
      this.$router.push(router);
    },
  },
};
</script>

<style>
.action-container {
  width: 30% !important;
  background-color: white;
  box-shadow: var(--atm-shadow);
  padding: 21px 0px !important;
  text-align: center;
  border-radius: 10px;
}

.secondActions-container {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.imageStyle {
  height: 50px;
}

.icon222Style ¨ {
  font-size: 2rem !important;
}

.image-disable {
  filter: grayscale(100%);
}
</style>
